import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevron-right', 'IconChevronRight', [["path",{"d":"M9 6l6 6l-6 6","key":"svg-0"}]]);